import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { ContentBoxSkeleton } from 'app/agriculture/components/ContentBox/ContentBoxSkeleton';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';

export function DeviceDetailsSkeleton() {
    return (
        <ContentBoxSkeleton variant="xl">
            <ContentBox.Section scrollable disableDivider>
                <ContentBox.Section disableDivider>
                    <SimpleGrid columns={3}>
                        <StatDisplaySkeleton showIconSkeleton />
                        <StatDisplaySkeleton showIconSkeleton />
                        <StatDisplaySkeleton showIconSkeleton />
                        <StatDisplaySkeleton showIconSkeleton />
                        <StatDisplaySkeleton showIconSkeleton />
                        <StatDisplaySkeleton showIconSkeleton />
                    </SimpleGrid>
                </ContentBox.Section>
            </ContentBox.Section>
        </ContentBoxSkeleton>
    );
}
